package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class MilestoneQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    objective_id: String,
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(481_005_651, arrayOf("milestone"), driver, "Milestone.sq", "selectAll",
      "SELECT milestone.id, milestone.objective_id, milestone.title, milestone.description, milestone.deadline, milestone.progress, milestone.order_index, milestone.created_at, milestone.updated_at, milestone.is_deleted, milestone.deleted_at, milestone.synced_at FROM milestone WHERE is_deleted = 0 ORDER BY deadline") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectAll(): Query<Milestone> = selectAll { id, objective_id, title, description,
      deadline, progress, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Milestone(
      id,
      objective_id,
      title,
      description,
      deadline,
      progress,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByObjective(objective_id: String, mapper: (
    id: String,
    objective_id: String,
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByObjectiveQuery(objective_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByObjective(objective_id: String): Query<Milestone> =
      selectByObjective(objective_id) { id, objective_id_, title, description, deadline, progress,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Milestone(
      id,
      objective_id_,
      title,
      description,
      deadline,
      progress,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    objective_id: String,
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectById(id: String): Query<Milestone> = selectById(id) { id_, objective_id, title,
      description, deadline, progress, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Milestone(
      id_,
      objective_id,
      title,
      description,
      deadline,
      progress,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    objective_id: String,
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_607_346_684, arrayOf("milestone"), driver, "Milestone.sq",
      "selectDirty",
      "SELECT milestone.id, milestone.objective_id, milestone.title, milestone.description, milestone.deadline, milestone.progress, milestone.order_index, milestone.created_at, milestone.updated_at, milestone.is_deleted, milestone.deleted_at, milestone.synced_at FROM milestone WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectDirty(): Query<Milestone> = selectDirty { id, objective_id, title, description,
      deadline, progress, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Milestone(
      id,
      objective_id,
      title,
      description,
      deadline,
      progress,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    objective_id: String,
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Milestone> = selectByIdAnyState(id) { id_,
      objective_id, title, description, deadline, progress, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Milestone(
      id_,
      objective_id,
      title,
      description,
      deadline,
      progress,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    objective_id: String,
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-227_295_189, """
        |INSERT INTO milestone(id, objective_id, title, description, deadline, progress, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindString(1, objective_id)
          bindString(2, title)
          bindString(3, description)
          bindString(4, deadline)
          bindLong(5, progress)
          bindLong(6, order_index)
          bindLong(7, created_at)
          bindLong(8, updated_at)
        }
    notifyQueries(-227_295_189) { emit ->
      emit("milestone")
    }
  }

  public fun update(
    title: String,
    description: String?,
    deadline: String?,
    progress: Long,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(117_651_003, """
        |UPDATE milestone
        |SET title = ?, description = ?, deadline = ?, progress = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, title)
          bindString(1, description)
          bindString(2, deadline)
          bindLong(3, progress)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(117_651_003) { emit ->
      emit("milestone")
    }
  }

  public fun updateProgress(
    progress: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_218_317_944,
        """UPDATE milestone SET progress = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, progress)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_218_317_944) { emit ->
      emit("milestone")
    }
  }

  public fun updateOrder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_909_132_755,
        """UPDATE milestone SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_909_132_755) { emit ->
      emit("milestone")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_207_758_105,
        """UPDATE milestone SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_207_758_105) { emit ->
      emit("milestone")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(684_163_932,
        """UPDATE milestone SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(684_163_932) { emit ->
      emit("milestone")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-1_387_820_312, """DELETE FROM milestone WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-1_387_820_312) { emit ->
      emit("milestone")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-4_864_487,
        """UPDATE milestone SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-4_864_487) { emit ->
      emit("milestone")
    }
  }

  private inner class SelectByObjectiveQuery<out T : Any>(
    public val objective_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("milestone", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("milestone", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_622_475_604,
        """SELECT milestone.id, milestone.objective_id, milestone.title, milestone.description, milestone.deadline, milestone.progress, milestone.order_index, milestone.created_at, milestone.updated_at, milestone.is_deleted, milestone.deleted_at, milestone.synced_at FROM milestone WHERE objective_id = ? AND is_deleted = 0 ORDER BY order_index, deadline""",
        mapper, 1) {
      bindString(0, objective_id)
    }

    override fun toString(): String = "Milestone.sq:selectByObjective"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("milestone", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("milestone", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(2_026_314_592,
        """SELECT milestone.id, milestone.objective_id, milestone.title, milestone.description, milestone.deadline, milestone.progress, milestone.order_index, milestone.created_at, milestone.updated_at, milestone.is_deleted, milestone.deleted_at, milestone.synced_at FROM milestone WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Milestone.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("milestone", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("milestone", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_122_199_675,
        """SELECT milestone.id, milestone.objective_id, milestone.title, milestone.description, milestone.deadline, milestone.progress, milestone.order_index, milestone.created_at, milestone.updated_at, milestone.is_deleted, milestone.deleted_at, milestone.synced_at FROM milestone WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Milestone.sq:selectByIdAnyState"
  }
}
